"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2886],{

/***/ 42886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _currencyProvider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4404);
/* harmony import */ var _authProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89149);
/* harmony import */ var _favouritesProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83155);
/* harmony import */ var _modalProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51472);
/* harmony import */ var _SearchContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65079);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40670);








var Providers = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), hydrated = ref[0], setHydrated = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        setHydrated(true) // Run only after hydration
        ;
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_currencyProvider__WEBPACK_IMPORTED_MODULE_1__/* .CurrencyContextProvider */ .SF, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_authProvider__WEBPACK_IMPORTED_MODULE_2__/* .AuthContextProvider */ .HD, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchContext__WEBPACK_IMPORTED_MODULE_5__/* .SearchContextProvider */ .Nd, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_favouritesProvider__WEBPACK_IMPORTED_MODULE_3__/* .FavouritesContextProvider */ .td, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modalProvider__WEBPACK_IMPORTED_MODULE_4__/* .ModalContextProvider */ .ny, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ResponsiveContext__WEBPACK_IMPORTED_MODULE_7__/* .ResponsiveProvider */ .$, {
                            children: hydrated ? children : null
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Providers);


/***/ }),

/***/ 89149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eu": function() { return /* binding */ useAuthContext; },
/* harmony export */   "HD": function() { return /* binding */ AuthContextProvider; }
/* harmony export */ });
/* unused harmony export AuthContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var AuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useAuthContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AuthContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var AuthContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isAgent = ref1[0], seIsAgent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), user = ref2[0], setUser = ref2[1];
    var isAuthorized = loggedIn && isAgent;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // When storage changes refetch
        setLoggedIn(localStorage.getItem("access_token") || false);
        seIsAgent(localStorage.getItem("isAgent") || false);
        setUser(localStorage.getItem("user") || false);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthContext.Provider, {
        value: {
            loggedIn: loggedIn,
            setLoggedIn: setLoggedIn,
            isAgent: isAgent,
            seIsAgent: seIsAgent,
            isAuthorized: isAuthorized,
            user: user,
            setUser: setUser
        },
        children: children
    });
};



/***/ }),

/***/ 83155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ useFavouritesContext; },
/* harmony export */   "td": function() { return /* binding */ FavouritesContextProvider; }
/* harmony export */ });
/* unused harmony export FavouritesContext */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_es_pull__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35242);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92375);
/* harmony import */ var _authProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89149);






var safeLocalStorage = {
    getItem: function(key) {
        try {
            return  true ? localStorage.getItem(key) : 0;
        } catch (e) {
            return null;
        }
    },
    setItem: function(key, value) {
        try {
            if (true) {
                localStorage.setItem(key, value);
            }
        } catch (e) {
        // localStorage not available (e.g., Safari private browsing)
        }
    }
};
var FavouritesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useFavouritesContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FavouritesContext);
    if (context === undefined) {
        throw new Error("useFavouritesContext was used outside of its Provider");
    }
    return context;
};
var FavouritesContextProvider = function(param) {
    var children = param.children;
    var isFavourite = function isFavourite(value) {
        return favourites.includes(value);
    };
    var addOrRemoveFavourite = function addOrRemoveFavourite(value) {
        var newFavourites = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(favourites);
        if (isFavourite(value)) {
            (0,lodash_es_pull__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(newFavourites, value);
        } else {
            newFavourites.push(value);
        }
        setFavourites(newFavourites);
        safeLocalStorage.setItem("favourites", newFavourites.join(","));
        if (loggedIn) {
            _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("user/favourites/update", {
                user_id: user,
                favourites: newFavourites
            }).catch(function(err) {
                return console.error(err);
            });
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), favourites = ref[0], setFavourites = ref[1];
    var ref1 = (0,_authProvider__WEBPACK_IMPORTED_MODULE_3__/* .useAuthContext */ .Eu)(), user = ref1.user, loggedIn = ref1.loggedIn;
    var hasInitializedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    // Load favourites from localStorage on initial client-side mount
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var storedFavourites = safeLocalStorage.getItem("favourites");
        if (storedFavourites && storedFavourites !== "") {
            setFavourites(storedFavourites.split(",").filter(Boolean));
        }
        hasInitializedRef.current = true;
    }, []);
    // Sync with database when user logs in
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!loggedIn || !hasInitializedRef.current) {
            return;
        }
        // Get current local favourites before async operation
        var localFavourites = safeLocalStorage.getItem("favourites");
        var localIds = localFavourites ? localFavourites.split(",").filter(Boolean) : [];
        _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("user/".concat(user, "/favourites")).then(function(res) {
            var dbFavourites = Array.isArray(res.data.favourites) ? res.data.favourites : [];
            // Merge local and DB favourites (union of both)
            var merged = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(localIds).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(dbFavourites))));
            setFavourites(merged);
            safeLocalStorage.setItem("favourites", merged.join(","));
            // Save merged result back to DB if there were local additions
            if (localIds.length > 0 && merged.length > dbFavourites.length) {
                _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("user/favourites/update", {
                    user_id: user,
                    favourites: merged
                }).catch(function(err) {
                    return console.error(err);
                });
            }
        }).catch(function(err) {
            return console.error(err);
        });
    }, [
        loggedIn,
        user
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FavouritesContext.Provider, {
        value: {
            favourites: favourites,
            isFavourite: isFavourite,
            addOrRemoveFavourite: addOrRemoveFavourite
        },
        children: children
    });
};



/***/ }),

/***/ 51472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ny": function() { return /* binding */ ModalContextProvider; },
/* harmony export */   "vR": function() { return /* binding */ useModalContext; }
/* harmony export */ });
/* unused harmony export ModalContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useModalContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var ModalContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), variant = ref2[0], setVariant = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), beforeClose = ref3[0], handleBeforeClose = ref3[1];
    var body =  true && document.querySelector("body");
    var handleShowModal = function() {
        setShow(true);
        body.classList.add("modal-open");
    };
    var handleCloseModal = function() {
        setShow(false);
        body.classList.remove("modal-open");
        // Clear content to reset state when modal closes
        // This ensures errors and form state are cleared for next opening
        setContent(false);
        setVariant([]);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) {
            beforeClose && beforeClose();
            handleCloseModal();
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: {
            handleShowModal: handleShowModal,
            handleCloseModal: handleCloseModal,
            handleBeforeClose: handleBeforeClose,
            setContent: setContent,
            content: content,
            setVariant: setVariant,
            show: show,
            variant: variant
        },
        children: children
    });
};



/***/ }),

/***/ 35242:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lodash_es_pull; }
});

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseRest.js
var _baseRest = __webpack_require__(69581);
// EXTERNAL MODULE: ./node_modules/lodash-es/_arrayMap.js
var _arrayMap = __webpack_require__(74073);
// EXTERNAL MODULE: ./node_modules/lodash-es/_baseIndexOf.js + 3 modules
var _baseIndexOf = __webpack_require__(36333);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_baseIndexOfWith.js
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOfWith(array, value, fromIndex, comparator) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (comparator(array[index], value)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ var _baseIndexOfWith = (baseIndexOfWith);

// EXTERNAL MODULE: ./node_modules/lodash-es/_baseUnary.js
var _baseUnary = __webpack_require__(21162);
// EXTERNAL MODULE: ./node_modules/lodash-es/_copyArray.js
var _copyArray = __webpack_require__(87215);
;// CONCATENATED MODULE: ./node_modules/lodash-es/_basePullAll.js






/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */
function basePullAll(array, values, iteratee, comparator) {
  var indexOf = comparator ? _baseIndexOfWith : _baseIndexOf/* default */.Z,
      index = -1,
      length = values.length,
      seen = array;

  if (array === values) {
    values = (0,_copyArray/* default */.Z)(values);
  }
  if (iteratee) {
    seen = (0,_arrayMap/* default */.Z)(array, (0,_baseUnary/* default */.Z)(iteratee));
  }
  while (++index < length) {
    var fromIndex = 0,
        value = values[index],
        computed = iteratee ? iteratee(value) : value;

    while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
      if (seen !== array) {
        splice.call(seen, fromIndex, 1);
      }
      splice.call(array, fromIndex, 1);
    }
  }
  return array;
}

/* harmony default export */ var _basePullAll = (basePullAll);

;// CONCATENATED MODULE: ./node_modules/lodash-es/pullAll.js


/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */
function pullAll(array, values) {
  return (array && array.length && values && values.length)
    ? _basePullAll(array, values)
    : array;
}

/* harmony default export */ var lodash_es_pullAll = (pullAll);

;// CONCATENATED MODULE: ./node_modules/lodash-es/pull.js



/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */
var pull = (0,_baseRest/* default */.Z)(lodash_es_pullAll);

/* harmony default export */ var lodash_es_pull = (pull);


/***/ })

}]);